import UnauthenticatedRoutes from './UnauthenticatedRoutes';
import AuthenticatedRoutes from './AuthenticatedRoutes';

export default [...UnauthenticatedRoutes, ...AuthenticatedRoutes];



// WEBPACK FOOTER //
// ./src/routes/CombinedRoutes.js